import ProductWrap from "./product-wrap";

export default ProductWrap;